<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>查询条件</div>
            <div class="ibox-tools" style="top:10px;">
              <el-button type="text" style="margin-right:10px;" @click="_moreCondition()">
                {{ myHousekeepingDispatchInfo.moreCondition == true ? '隐藏' : '更多' }}
              </el-button>
            </div>
          </div>
          <div class="">
            <el-form :inline="true" :model="myHousekeepingDispatchInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-form-item>
                  <el-input placeholder="请输入工单编号" v-model="myHousekeepingDispatchInfo.conditions.cartId"></el-input>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <el-input placeholder="请输入申请人" v-model="myHousekeepingDispatchInfo.conditions.applyName"></el-input>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <el-input placeholder="请输入联系电话" v-model="myHousekeepingDispatchInfo.conditions.applyTel"></el-input>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="_queryHousekeepingPoolMethod()">
                  <i class="el-icon-search"></i> 查询
                </el-button>
                <el-button type="primary" size="small" @click="_resetHousekeepingPoolMethod()">
                  <i class="el-icon-refresh"></i> 重置
                </el-button>
              </el-form-item>
            </el-form>
            <el-form :inline="true" :model="myHousekeepingDispatchInfo.conditions" class="flex justify-start"
              v-if="myHousekeepingDispatchInfo.moreCondition == true">
              <el-form-item>
                <el-form-item>
                  <el-select v-model="myHousekeepingDispatchInfo.conditions.state" placeholder="请选择状态"
                    style="width:100%">
                    <el-option label="请选择状态" disabled value=""></el-option>
                    <el-option v-for="(item, index) in myHousekeepingDispatchInfo.states" :key="index" :label="item.name"
                      :value="item.statusCd"></el-option>
                  </el-select>
                </el-form-item>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div><span>{{ myHousekeepingDispatchInfo.conditions.roomName }}</span>服务已办</div>
          </div>
          <div class="">
            <el-table :data="myHousekeepingDispatchInfo.pools" style="width: 100%">
              <el-table-column prop="servName" label="服务名称" align="center"></el-table-column>
              <el-table-column prop="cartId" label="订单编号" align="center"></el-table-column>
              <el-table-column prop="applyName" label="申请人" align="center"></el-table-column>
              <el-table-column prop="applyTel" label="联系方式" align="center"></el-table-column>
              <el-table-column prop="appointmentTime" label="预约时间" align="center"></el-table-column>
              <el-table-column label="状态" align="center">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.state == '1800' && (scope.row.returnVisitFlag == '001' || scope.row.returnVisitFlag == '002')">
                    {{ scope.row.stateName }}(定时任务处理)
                  </span>
                  <span v-else>
                    {{ scope.row.stateName }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" @click="_openDetail(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
              layout="total, prev, pager, next" :total="total">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryStaffFinishServ, closeOrder } from '@/api/goods/myHousekeepingDispatchManageApi'

export default {
  name: 'MyHousekeepingDispatchManage',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      myHousekeepingDispatchInfo: {
        pools: [],
        total: 0,
        records: 1,
        moreCondition: false,
        repairName: '',
        currentRepairId: '',
        states: [],
        conditions: {
          cartId: '',
          applyName: '',
          applyTel: '',
          repairType: '',
          roomId: '',
          roomName: '',
          ownerId: '',
          state: '',
          page: 1,
          row: 10,
          shopId: ''
        }
      }
    }
  },
  created() {
    this._initMethod()
    this._initEvent()
  },
  methods: {
    async _initMethod() {
      try {
        const { data } = await getDict('housekeeping_serv_pool', 'state')
        this.myHousekeepingDispatchInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
      this._listHousekeepingPools(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _initEvent() {

    },
    async _listHousekeepingPools(_page, _rows) {
      this.myHousekeepingDispatchInfo.conditions.page = _page
      this.myHousekeepingDispatchInfo.conditions.row = _rows
      this.myHousekeepingDispatchInfo.conditions.shopId = getShopId()

      const params = {
        ...this.myHousekeepingDispatchInfo.conditions,
        cartId: this.myHousekeepingDispatchInfo.conditions.cartId.trim(),
        applyName: this.myHousekeepingDispatchInfo.conditions.applyName.trim(),
        applyTel: this.myHousekeepingDispatchInfo.conditions.applyTel.trim()
      }

      try {
        const res = await queryStaffFinishServ(params)
        this.myHousekeepingDispatchInfo.total = res.total
        this.myHousekeepingDispatchInfo.records = res.records
        this.myHousekeepingDispatchInfo.pools = res.data
        this.total = res.records
        this.currentPage = _page
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _moreCondition() {
      this.myHousekeepingDispatchInfo.moreCondition = !this.myHousekeepingDispatchInfo.moreCondition
    },
    _openDetail(pool) {
      this.$router.push(`/pages/housekeeping/housekeepingServDetail?poolId=${pool.poolId}`)
    },
    async _closeRepairDispatchOrder(orderInfo) {
      const _repairDispatchParam = {
        repairId: this.myHousekeepingDispatchInfo.currentRepairId,
        context: orderInfo.remark,
        shopId: getShopId()
      }

      if (orderInfo.state == '1100') {
        _repairDispatchParam.state = '10002'
      } else {
        _repairDispatchParam.state = '10003'
      }

      try {
        await closeOrder(_repairDispatchParam)
        this._listHousekeepingPools(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openDispatchRepairDetail(ownerRepair) {
      console.log(ownerRepair)
      this.$emit('ownerRepairDetail', 'openOwnerRepairDetailModal', ownerRepair)
    },
    _queryHousekeepingPoolMethod() {
      this._listHousekeepingPools(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetHousekeepingPoolMethod() {
      this.myHousekeepingDispatchInfo.conditions.cartId = ""
      this.myHousekeepingDispatchInfo.conditions.applyName = ""
      this.myHousekeepingDispatchInfo.conditions.applyTel = ""
      this.myHousekeepingDispatchInfo.conditions.state = ""
      this._listHousekeepingPools(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handleCurrentChange(val) {
      this._listHousekeepingPools(val, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
}
</style>